import Entity from 'lib/Entity';

export default class Reaction extends Entity {
  getName(): string {
    return this.get('name');
  }

  getEmojiCode(): string {
    return `:${this.get('name')}:`; // API returns Emoji shortcodes with no colons
  }

  // @ts-expect-error ts-migrate(2304) FIXME: Cannot find name 'ReactionUserSummaryGQL'.
  getUsers(): ReactionUserSummaryGQL[] {
    return this.get('users');
  }

  getUserNames(): Array<string> {
    // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'user' implicitly has an 'any' type.
    return this.get('users').map((user) => user['name']);
  }

  getUserUuids(): Array<string> {
    // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'user' implicitly has an 'any' type.
    return this.get('users').map((user) => user['uuid']);
  }

  getCount(): number {
    return this.get('count');
  }

  getHasReacted(): boolean {
    return this.get('has_reacted');
  }

  // @ts-expect-error ts-migrate(2304) FIXME: Cannot find name 'ReactionGQL'.
  toGraphQL(): ReactionGQL {
    return {
      __typename: 'Reaction',
      name: this.getName(),
      count: this.getCount(),
      hasReacted: this.getHasReacted(),
      users: this.getUsers().map((user) => ({
        __typename: 'ReactionUserSummary',
        ...user,
      })),
    };
  }
}
